module.exports = __webpack_public_path__ + "img/zxxqy.6f806533.png";